import { createContext, useReducer } from 'react'
import { type ItemProviderProps, type ItemDataContextProps, type ItemDispatchContextProps, type Item } from 'src/types'

import { reducer } from './reducer'
import { items as itemsBackup } from 'src/data'

/* TEMP */
const itemData: Record<string, Item> = {}

itemsBackup.forEach((entry) => {
  itemData[entry.id] = entry
})

export const ItemDataContext = createContext<ItemDataContextProps>({ items: itemData })
ItemDataContext.displayName = 'ItemDataContext'

export const ItemDispatchContext = createContext<ItemDispatchContextProps>({ dispatchItems: () => null })
ItemDispatchContext.displayName = 'ItemDispatchContext'

export const ItemProvider = ({ children }: ItemProviderProps) => {
  const [items, dispatchItems] = useReducer(reducer, itemData)
  
  return (
    <ItemDataContext.Provider value={{ items }}>
      <ItemDispatchContext.Provider value={{ dispatchItems }}>
        {children}
      </ItemDispatchContext.Provider>
    </ItemDataContext.Provider>
  )
}
